import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';


registerFragment('cbdce-border-line', (fragmentElement, configuration, meta) => {

});

if (import.meta.hot) {
    import.meta.hot.accept();
}
